import { Skeleton, Stack } from "@mui/material";

export default function TopSectionSkeleton() {
    return (
        <Stack direction="row" gap={3}>
            <Skeleton variant="rounded" height={300} width={"50%"} />
            <Skeleton variant="rounded" height={300} width={"100%"} />
        </Stack>
    )
}